__turbopack_context__.v({
  "blue": "gW1A4G_blue",
  "blue_ghost": "gW1A4G_blue_ghost",
  "heart_icon": "gW1A4G_heart_icon",
  "light_blue": "gW1A4G_light_blue",
  "link_button_content_disabled": "gW1A4G_link_button_content_disabled",
  "max": "gW1A4G_max",
  "min": "gW1A4G_min",
  "red": "gW1A4G_red",
  "transparent": "gW1A4G_transparent",
  "white": "gW1A4G_white",
  "white_ghost": "gW1A4G_white_ghost",
  "yellow": "gW1A4G_yellow",
});
